// extracted by mini-css-extract-plugin
module.exports = {"comp":"A_comp__XLyct"};